import { render, staticRenderFns } from "./Perms.vue?vue&type=template&id=8040bfc8&"
import script from "./Perms.vue?vue&type=script&lang=ts&"
export * from "./Perms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports